import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-6MM43HOH.mjs";
import "./chunk-YAJQ3QCK.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
